/**
 * Auth token persistence — survives tab refresh, cleared when the tab/browser closes.
 */
export const SESSION_TOKEN_KEY = 'msc_x_access_token';

export function getStoredToken() {
  try {
    return sessionStorage.getItem(SESSION_TOKEN_KEY) || '';
  } catch (err) {
    return '';
  }
}

export function storeToken(token) {
  try {
    if (token) {
      sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SESSION_TOKEN_KEY);
    }
  } catch (err) {
    // Private mode / blocked storage — in-memory session only
  }
}

export function clearStoredToken() {
  storeToken('');
}
